import { IBlockContent, IParagraphCalloutStripe } from '../../interfaces';

export const HomepageContent: IBlockContent[] = [
  {
    fieldTitle: 'AI-powered talent marketplace',
    fieldId: 'header',
    fieldDescription:
      'Transform how you discover, develop, and deploy talent. With AI-driven tools, Talenteer aligns talent with company goals, matches the right people to the right roles, and builds an agile workforce.',
    blockItems: [
      {
        fieldTitle: '',
        fieldImage: {
          alt: 'Image description',
          imagePath: 'homepage/main-picture.png',
        },
      },
    ],
  },
  {
    fieldTitle: 'Proven solution for building top-performing teams',
    fieldId: 'proven-solution',
    fieldDescription: '',
    blockItems: [
      {
        fieldTitle: '2x',
        fieldDescription: 'Boost in internal recruitment',
      },
      {
        fieldTitle: 'Quick setup',
        fieldDescription: 'Go live\nin 2+ weeks',
      },
      {
        fieldTitle: '5x',
        fieldDescription: 'More employees find opportunities internally',
      },
      {
        fieldTitle: '24/7 support',
        fieldDescription: 'For seamless operations',
      },
      {
        fieldTitle: 'Deliver faster',
        fieldDescription: 'Timely connect top talents to key business opportunities',
      },
      {
        fieldTitle: '25%',
        fieldDescription: 'Growth in employee skills visibility',
      },
      {
        fieldTitle: 'Enterprise ready',
        fieldDescription: 'Proven success with 500+ employee organizations',
      },
    ],
  },
  {
    fieldTitle: 'Main features',
    fieldId: 'main-features',
    fieldDescription: '',

    blockItems: [
      {
        fieldTitle: 'For managers',
        faq: [
          {
            question: 'AI-driven talent matching',
            answer:
              'Quickly build teams by identifying the best candidates for roles and projects using real-time data on skills, experience, and availability',
            content: '',
          },
          {
            question: 'Job postings',
            answer:
              'Easily create internal and external job postings with precise skill requirements and qualifications',
            content: '',
          },
          {
            question: 'Talent pool overview',
            answer: 'Quickly spot internal talent ready for new challenges or growth opportunities',
            content: '',
          },
          {
            question: 'Streamlined recruitment process',
            answer: 'Simplify external hiring by organizing applications and automating candidate ranking',
            content: '',
          },
          {
            question: 'Data-driven insights',
            answer: 'Make objective, informed decisions with actionable insights that reduce bias',
            content: '',
          },
          {
            question: 'Talent development support',
            answer: 'Identify growth opportunities for employees and encourage internal mobility',
            content: '',
          },
        ],
      },
      {
        fieldTitle: 'For employees',
        faq: [
          {
            question: 'Talent profiles',
            answer: 'Allow employees to showcase their skills, certifications, work experience, and career goals',
            content: '',
          },
          {
            question: 'Centralized opportunity hub',
            answer:
              'Create a one-stop platform where employees can easily access and apply for internal roles, projects, and mentoring opportunities',
            content: '',
          },
          {
            question: 'Transparent career pathing',
            answer: 'Provide clear visibility into potential career progression and available opportunities',
            content: '',
          },
          {
            question: 'AI-driven recommendations',
            answer: 'Use AI to offer personalized job and project recommendations based on employee profiles',
            content: '',
          },
          {
            question: 'Easy application process',
            answer:
              'Simplify applications for roles and projects, reducing administrative burdens for both employees and managers',
            content: '',
          },
          {
            question: 'Mentorship and growth opportunities',
            answer:
              'Connect employees with mentorship programs and networking opportunities to support their personal and professional growth',
            content: '',
          },
        ],
      },
    ],
  },
  {
    fieldTitle: 'Use cases',
    fieldId: 'find-out',
    fieldDescription: '',
    blockItems: [
      {
        fieldTitle: 'How Talenteer’s AI matching works',
        fieldLink: '/use-cases/how-ai-matching-works',
        fieldDescription:
          'Discover how Talenteer’s AI-driven matching connects top talent with the right opportunities. Learn how our platform simplifies internal mobility, boosts employee engagement, and streamlines external hiring for faster, smarter decisions.',
      },
      {
        fieldTitle: 'Maximize productivity and engagement',
        fieldLink: '/use-cases/maximize-productivity-and-engagement',
        fieldDescription:
          'Unlock new opportunities and retain top talents with Talenteer: promoting skill exploration, talent mobility, and reducing external hiring needs',
      },
      {
        fieldTitle: 'Improve operational efficiency',
        fieldLink: '/use-cases/empower-agile-talent-allocation',
        fieldDescription:
          'Optimize resource allocation and improve operational efficiency with Talenteer: tap into a broader talent pool to find the right skills for your projects',
      },
      {
        fieldTitle: 'Make talent management cost-efficient',
        fieldLink: '/use-cases/cultivate-cost-efficiency',
        fieldDescription:
          "Discover Talenteer's powerful solutions to unlock cost-efficient talent management strategies for your organization.",
      },
      {
        fieldTitle: 'Streamline in-house recruitment',
        fieldLink: '/use-cases/streamline-in-house-recruitment',
        fieldDescription:
          "Discover Talenteer's powerful platform to elevate your hiring game with swift positions filling, promote cross-teams collaboration, accelerate onboarding with internal talents, and drive efficiency through effortless candidate screening.",
      },
      {
        fieldTitle: 'Embrace cross-functional collaboration',
        fieldLink: '/use-cases/embrace-cross-functional-collaboration',
        fieldDescription:
          'Empower your workforce through cross-functional engagement. Talenteer fosters skill growth, promoting internal networking for knowledge exchange',
      },
    ],
  },
  {
    fieldTitle: 'Address key talent management challenges',
    fieldId: 'challenges',
    fieldDescription: '',
    blockItems: [
      {
        fieldTitle: 'Minimize employee turnover',
        fieldDescription:
          'Offer growth opportunities that increase loyalty and job satisfaction, helping retain your top talent.',
      },
      {
        fieldTitle: 'Make the internal talent pool transparent',
        fieldDescription:
          'Easily manage open positions, track employee availability, and align career aspirations to optimize internal mobility.',
      },
      {
        fieldTitle: 'Boost business efficiency',
        fieldDescription:
          'Leverage AI to quickly identify ideal candidates, build high-performing teams, and adapt faster to changing market conditions.',
      },
      {
        fieldTitle: 'Nurture mentoring program',
        fieldDescription:
          'Match employees with mentors based on career goals, fostering upskilling, reskilling, and knowledge sharing for long-term growth.',
      },
      {
        fieldTitle: 'Reduce recruiting costs',
        fieldDescription:
          'Promote internal hiring to cut recruitment and onboarding costs while using data-driven insights to build a robust talent development strategy.',
      },
      {
        fieldTitle: 'Centralize talent information',
        fieldDescription:
          'Unify employee skills and capabilities in one platform, seamlessly integrating with your existing HR systems for easy access and analysis.',
      },
    ],
  },
  {
    fieldTitle: 'Achieve more with the right talent in the right place',
    fieldId: 'cta-ensure',
    blockItems: [],
    fieldDescription: '',
  },
  {
    fieldTitle: 'Check out our blog',
    fieldId: 'blogs',
    fieldDescription: '',
    blockItems: [
      {
        fieldTitle: 'Talenteer won Gold in Brandon Hall Group’s Excellence in Technology Awards',
        fieldDescription:
          'Talenteer won Gold award in Brandon Hall Group’s 2023 Excellence in Technology Awards - Best Integrated Talent Management Platform category.',
        fieldImage: {
          imagePath: 'blogs/talenteer-won-gold/talenteer-won-gold-header-related.jpg',
          alt: 'Cover for blog Talenteer Won Gold',
        },
        fieldLink: 'blog/talenteer-won-gold-in-brandon-hall-groups-excellence-in-technology-awards',
      },
      {
        fieldTitle: 'The talent marketplace: A comprehensive guide',
        fieldDescription:
          'A talent marketplace is an HR platform that can help you meet business goals more effectively and increase employee engagement. Read on to learn how.',
        fieldImage: {
          imagePath: 'blogs/talent-marketplace/talent-marketplace-related.jpg',
          alt: 'Cover for blog Talent Marketplace',
        },
        fieldLink: 'blog/talent-marketplace',
      },
      {
        fieldTitle: 'HR analytics: definition, best practices & examples',
        fieldDescription:
          'Explore the key features and best practices of HR analytics. Learn how data management and straightforward metrics help HR specialists and businesses.',
        fieldImage: {
          imagePath: 'blogs/hr-analytics/hr-analytics-related.jpg',
          alt: 'Cover for blog HR Analytics',
        },
        fieldLink: 'blog/hr-analytics',
      },
    ],
  },
  {
    fieldTitle: 'Frequently asked questions',
    fieldId: 'faq',
    fieldDescription: '',
    blockItems: [
      {
        fieldTitle: 'What is Talenteer, and how can it help my company?',
        fieldDescription:
          'Talenteer is an AI-driven internal talent marketplace that transforms how you manage and deploy your workforce. By quickly matching internal talent with opportunities, it accelerates hiring, enhances employee retention, and reduces recruitment costs. With Talenteer, you can optimize resource utilization, foster cross-departmental collaboration, and drive innovation within your organization.',
      },
      {
        fieldTitle: 'How does Talenteer use AI to improve HR processes?',
        fieldDescription:
          'Being a workforce management software, Talenteer helps managers quickly build teams, fill vacancies, and start projects by using AI to match the right talent to the right roles. This speeds up hiring and boosts productivity. Employees also benefit from clear career growth opportunities and a better path for internal advancement.',
      },
      {
        fieldTitle: 'How can it improve employee retention and reduce turnover?',
        fieldDescription:
          'The platform increases awareness about possible ways of development in the company. It helps employees find roles that match their skills and aspirations, increasing job satisfaction. By promoting internal mobility and recognizing talent, Talenteer fosters a more engaged and loyal workforce.',
      },
      {
        fieldTitle: 'How does internal talent management help the company thrive?',
        fieldDescription:
          'Internal talent management helps a company thrive by leveraging existing employees’ skills and experience, which boosts efficiency and reduces recruitment costs. It supports upskilling and reskilling, allowing employees to grow and adapt to new roles, while developing top performers for future leadership positions. This approach fosters engagement and loyalty, ensuring a quicker response to business needs and driving overall organizational success.',
      },
      {
        fieldTitle: 'Can Talenteer integrate with our current HR systems?',
        fieldDescription:
          'Yes, Talenteer connects with existing platforms to enhance talent management, streamline data flow, and ensure consistent information across systems. It can be integrated with different types of systems, such as SSO, HCM/HRM systems, task tracking systems, and corporate messengers.',
      },
    ],
  },
];

export const CtaBook: IParagraphCalloutStripe = {
  fieldTitle: 'Improve adaptability to change',
  fieldId: 'cta_book',
  fieldDescription: 'Book a demo',
  fieldSecondaryDescription: 'with talent development software and improved analytics.',
};
